<template>
  <b-form @submit="generate_qr">
    <b-form-group id="input-group-2" label="Bus Number" label-for="input-2">
      <b-form-input
        id="input-2"
        v-model="busNumber"
        placeholder="Enter Bus Number"
        required
      ></b-form-input>
    </b-form-group>

    <b-form-group id="input-group-3" label="Event" label-for="input-3">
      <b-form-select
        id="input-3"
        v-model="event"
        :options="events"
        required
      ></b-form-select>
    </b-form-group>

    <b-button variant="primary" @click="generate_qr">Generate QR Code</b-button>
  </b-form>
</template>

<script>
import axios from "axios";
import { mapGetters, mapMutations } from "vuex";
import { svgExport } from "svg-in-png";

export default {
  mixins: [],
  components: {},
  props: {},
  data: () => ({
    busNumber: "",
    event: "ALL_CLEAR",
    events: [
      { value: "ALL_CLEAR", text: "All Clear" },
      { value: "SIGN_ON", text: "Sign On" },
    ],
  }),
  methods: {
    ...mapMutations(["showMessage"]),
    generate_qr() {
      var vm = this;

      axios.defaults.headers.common["Authorization"] = `Bearer ${this.token}`;
      axios
        .post(`${process.env.VUE_APP_ROOT_API}/api/generate_qr/`, {
          code: this.busNumber,
          event: this.event,
        })
        .then(function (response) {
          // handle success
          let svg = response.data;

          // Create SVG for the QR code
          let svgElementContainer = document.createElement("container");
          svgElementContainer.setAttribute("id", "svgElementContainer");
          svgElementContainer.innerHTML = svg;
          document.body.appendChild(svgElementContainer);

          // // Create SVG for the label
          // let newText = document.createElementNS(
          //   "http://www.w3.org/2000/svg",
          //   "text"
          // );
          // let label = vm.busNumber + " " + vm.event;
          // newText.setAttributeNS(null, "x", "50%");
          // newText.setAttributeNS(null, "y", "98%");
          // newText.setAttributeNS(null, "width", "100%");
          // newText.setAttributeNS(null, "height", "5%");
          // newText.setAttributeNS(null, "font-family", "Arial");
          // newText.setAttributeNS(null, "font-size", "200%");
          // newText.setAttributeNS(null, "text-anchor", "middle");
          // newText.appendChild(document.createTextNode(label));
          // // Add label to svg
          // let svgElements = document.getElementsByTagName("svg");
          // document
          //   .getElementsByTagName("svg")
          //   [svgElements.length - 1].appendChild(newText);
          // // let svgWithCaptionString = new XMLSerializer().serializeToString(
          // //   document.getElementsByTagName("svg")[svgElements.length - 1]
          // // );

          // Convert to png
          let fileName = vm.busNumber + "-" + vm.event;
          svgExport({
            id: "svgElementContainer",
            titleToExport: fileName,
            options: {
              size: { width: 800, height: 800 },
            },
          });

          // Remove svg from screen
          document.body.removeChild(svgElementContainer);

          // let blob = new Blob([svgWithCaptionString], {
          //   type: "image/svg+xml",
          // });
          // let url = URL.createObjectURL(blob);
          // let fileLink = document.createElement("a");
          // let fileName = vm.busNumber + "_" + vm.event;

          // fileLink.href = url;
          // fileLink.setAttribute("download", fileName);
          // document.body.appendChild(fileLink);
          // fileLink.click();
        })
        .catch(function (error) {
          // handle error
          vm.showMessage({
            message: "Something went wrong",
            type: "danger",
            show: true,
          });
        })
        .then(function () {
          // always executed
        });

      return false;
    },
  },
  computed: {
    ...mapGetters({
      token: "AuthModule/token",
    }),
  },
  watch: {},
  created() {},
};
</script>
